<!--采购付款申请-->
<template>
    <div id="applyPayment" v-loading="loading">
        <el-form :rules="rules" :model="submitData" label-width="120px" ref="submitData">
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="需支付总金额">
                            <el-input type="number" step="0.01" v-model="orderData.SurplusMoney" disabled></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="待支付金额">
                            <el-input type="number" step="0.01" v-model="waitPay" disabled></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="已支付金额">
                            <el-input type="number" step="0.01" v-model="orderData.Paid" :disabled="true"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="结算方式" prop="PayType">
                            <el-select v-model="submitData.PayType" placeholder="请选择" style="width: 100%" @change="payTypeChange($event)" :disabled="ReadOnly">
                                <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="申请付款金额" prop="PaymentAmount">
                            <el-input type="number" step="0.01" v-model="submitData.PaymentAmount" :min="0" :disabled="ReadOnly"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="18">
                    <div class="grid-content bg-purple">
                        <el-form-item label="备注">
                            <el-input v-model="submitData.Remark" :disabled="ReadOnly"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <div v-if="isShowAccountZone && !ReadOnly">
                    <div style="font-size: 16px; margin: 5px 20px 15px 30px; color: #888888">付款账号选择区域</div>
                    <el-col :span="23">
                        <div class="grid-content bg-purple">
                            <el-form-item label="账号信息">
                                <el-select
                                    remote
                                    filterable
                                    default-first-option
                                    placeholder="请选择供应商账号信息"
                                    @change="accountChange($event)"
                                    style="width: 100%"
                                    v-model="submitData.AccountName"
                                >
                                    <el-option v-for="optionItem in accountList" :key="optionItem.Id" :data-msg="optionItem" :label="optionItem.AccountName" :value="optionItem.Id">
                                        <div class="option-content">
                                            <div style="margin-right: 30px">{{ '账户名：' + optionItem.AccountName }}</div>
                                            <div style="margin-right: 30px">{{ '账号：' + optionItem.Account }}</div>
                                            <div style="margin-right: 30px" v-if="optionItem.Bank">{{ '开户行：' + optionItem.Bank }}</div>
                                            <div v-if="optionItem.Remark">{{ '备注：' + optionItem.Remark }}</div>
                                        </div>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="1">
                        <img src="../../../assets/images/account.png" class="addicon" @click="addAccount(false)" title="添加账号信息" />
                    </el-col>
                </div>
            </el-row>
        </el-form>
        <div class="btn-ctn">
            <el-button size="small" class="search-btn" @click="cancel()" v-if="!ReadOnly">取消</el-button>
            <el-button size="small" class="search-btn btn-primary" @click="submitForm()" v-if="isCanApply && !ReadOnly">提交申请</el-button>
        </div>
        <div>
            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="form-uploadImg">
                        <!--改为由财务上传，其它人只能查看-->
                        <div>流水单据</div>
                        <el-upload
                            :action="uploadImgUrl"
                            :data="uploadImgData"
                            :headers="headerObj"
                            :file-list="orderImages"
                            list-type="picture-card"
                            accept="image/jpeg, image/png"
                            :on-preview="onUploadPreview"
                            :on-remove="onUploadRemove"
                            :before-remove="beforeRemove"
                            :on-success="onUploadSuccess"
                            :disabled="true"
                            class="hideUpload"
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogImageVisible" append-to-body>
                            <img width="100%" :src="dialogImageUrl" alt />
                        </el-dialog>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div>
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border
                show-summary
                :summary-method="getSummaries_apply"
                style="width: 100%; margin-bottom: 0px; margin-top: 15px"
            >
                <el-table-column show-overflow-tooltip width="190px" prop="PayCode" label="单号"></el-table-column>
                <el-table-column show-overflow-tooltip width="150px" prop="SumPayable" label="订单总金额"></el-table-column>
                <!-- <el-table-column show-overflow-tooltip width="100px" prop="AlreadyPaid" label="已付款金额"></el-table-column> -->
                <el-table-column show-overflow-tooltip width="150px" prop="ApplyPay" label="申请付款金额"></el-table-column>
                <el-table-column show-overflow-tooltip width="150px" prop="NowPay" label="实付金额"></el-table-column>
                <!-- <el-table-column show-overflow-tooltip width="120px" prop="Unpaid" label="剩余申请金额"></el-table-column> -->
                <el-table-column show-overflow-tooltip width="100px" prop="PayTypeName" label="结算方式">
                    <template slot-scope="scope">
                        <el-popover
                            placement="right"
                            width="400"
                            trigger="click"
                            v-if="
                                (scope.row.PayType == '20' || scope.row.PayType == '25' || scope.row.PayType == '30' || scope.row.PayType == '35') &&
                                (scope.row.Bank || scope.row.AccountName || scope.row.Account)
                            "
                        >
                            <div class="account-info">
                                <span v-if="scope.row.Bank">{{ '开户行：' + scope.row.Bank }}</span>
                                <span v-if="scope.row.AccountName">{{ '账户名：' + scope.row.AccountName }}</span>
                                <span v-if="scope.row.Account">{{ '账号：' + scope.row.Account }}</span>
                            </div>
                            <i slot="reference" class="el-icon-info" style="font-size: 18px; color: #409eff" title="支付账号信息"></i>
                        </el-popover>
                        <span>{{ scope.row.PayTypeName }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="ApplyName" label="申请人"></el-table-column>
                <el-table-column show-overflow-tooltip width="160px" prop="CreateTime" label="申请时间"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100px" prop="Remark" label="备注"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div class="ops-ctn" v-if="!scope.row.IsConfirm && !scope.row.IsCancel && !ReadOnly">
                            <el-button title="撤销" size="mini" type="text" @click="cancelPayRecord(scope.row.Id)">撤销</el-button>
                        </div>
                        <div class="ops-ctn" v-else-if="!scope.row.IsConfirm && scope.row.IsCancel">已撤销</div>
                        <div class="ops-ctn" v-else-if="scope.row.IsConfirm && !scope.row.IsCancel">已确认</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog :close-on-click-modal="false" title="供应商支付账号信息" :visible.sync="accountDialogVisible" append-to-body width="1000px">
            <div class="dialog-content" v-if="accountDialogVisible">
                <payAccount ref="payAccount" :entpCusId="orderData.EntpCusId" @closeDialog="closeAccountDialog"></payAccount>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import payAccount from '@/components/business/supplierManage/payAccount';
export default {
    name: '',
    props: {
        orderData: { type: Object },
        type: { type: String } //操作类型
    },
    components: { payAccount },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            ReadOnly: true,
            userMsg: userMsg,
            loading: true,
            waitPay: 0,
            payWayList: [],
            accountDialogVisible: false,
            submitData: {
                PayType: '',
                PaymentAmount: '',
                EntpCusPOId: '',
                Remark: '',
                Bank: '',
                AccountName: '',
                Account: ''
            },
            rules: {
                PayType: [{ required: true, message: '该项必填', trigger: 'change' }],
                PaymentAmount: [{ required: true, message: '该项必填', trigger: 'change' }]
            },
            orderImages: [],
            uploadImgData: null,
            uploadImgUrl: this.$util.BASE_URL + '/EntpSaleOrder/AddOrderImage',
            headerObj: {
                'access-key': userMsg.Token,
                reqApp: 'yqgPC'
            },
            dialogImageUrl: '',
            uploadImgFile: null,
            dialogImageVisible: false,
            isCanApply: true,
            payDataCount: 0,
            tableData: [],
            cancelPayRecordData: {
                Id: '',
                OperateType: 0
            },
            isShowAccountZone: false,
            accountList: [],
            innerVisible: false
        };
    },
    mounted() {
        //只有是申请付款时才能做操作
        if (this.type == '5') {
            this.ReadOnly = false;
        }
        this.uploadImgData = {
            OrderId: this.orderData.EntpCusPOId,
            OrderType: 1
        };
        this.getPay();
        this.getOrderDetails();
    },
    // beforeDestroy() {
    //   //注销粘贴事件
    //   document.removeEventListener("paste", this.handlePaste, false);
    // },
    methods: {
        cancel() {
            //注销粘贴事件
            // document.removeEventListener("paste", this.handlePaste, false);
            this.$emit('closeReceipt');
        },
        submitForm() {
            if (this.submitData.PaymentAmount <= 0) {
                this.$util.warningMsg('申请付款金额必须大于0');
                return;
            }
            if (parseFloat(this.submitData.PaymentAmount) > parseFloat(this.waitPay)) {
                this.$confirm('付款款金额已超过待支付金额，是否继续申请付款？', '提示', {
                    confirmButtonText: '确定继续申请',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.$refs['submitData'].validate(valid => {
                            if (valid) {
                                this.loading = true;
                                this.$util
                                    .axiosPost({
                                        url: '/api/EntpPurchaseOrder/ApplyEnterpriseSupplierPurchaseOrderPayment',
                                        data: this.submitData,
                                        hideLoading: true
                                    })
                                    .then(res => {
                                        this.$util.successMsg('申请付款成功');
                                        this.getOrderDetails();
                                        this.loading = false;
                                    })
                                    .catch(() => {
                                        this.loading = false;
                                    });
                            } else {
                                return false;
                            }
                        });
                    })
                    .catch(() => {});
            } else {
                this.$refs['submitData'].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: '/api/EntpPurchaseOrder/ApplyEnterpriseSupplierPurchaseOrderPayment',
                                data: this.submitData,
                                hideLoading: true
                            })
                            .then(res => {
                                this.$util.successMsg('申请付款成功');
                                this.getOrderDetails();
                                this.loading = false;
                            })
                            .catch(() => {
                                this.loading = false;
                            });
                    } else {
                        return false;
                    }
                });
            }
        },
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        getOrderDetails() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpPurchaseOrder/GetEntpPurOrderOnlyDetailById',
                    data: {
                        EntpCusPOId: this.orderData.EntpCusPOId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.getTableData();

                    let data = res.data;

                    this.submitData.Remark = '';
                    this.orderData.SurplusMoney = data.SurplusMoney;
                    this.orderData.Paid = data.Paid;

                    this.submitData.EntpCusPOId = data.EntpCusPOId;
                    this.submitData.PayType = data.PayType;
                    this.submitData.Remark = '';

                    let need = data.SurplusMoney - data.Paid;
                    this.waitPay = need <= 0 ? 0 : need.toFixed(2);
                    // this.submitData.PaymentAmount = need <= 0 ? 0 : need.toFixed(2);
                    //可申请金额应该为
                    this.submitData.PaymentAmount = data.CanApplyMoney >= 0 ? data.CanApplyMoney.toFixed(2) : data.SurplusMoney;
                    this.isCanApply = !data.IsPay;

                    this.orderImages = data.OrderImages;
                    for (let j = 0; j < this.orderImages.length; j++) {
                        this.orderImages[j].name = this.orderImages[j].Id;
                        this.orderImages[j].url = this.$util.QN_URL_BASE + this.orderImages[j].ImgUrl;
                    }
                    this.payTypeChange(data.PayType);
                    // if (!this.ReadOnly && this.isCanApply) {
                    //   this.$nextTick(() => {
                    //     //注册粘贴事件
                    //     document.addEventListener("paste", this.handlePaste, false);
                    //   });
                    // }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetPaymentAndReceiptRecordsByOId',
                    data: { orderId: this.orderData.EntpCusPOId },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.payDataCount = res.count;
                    this.tableData = data;
                });
        },
        cancelPayRecord(id) {
            if (id) {
                this.$confirm('是否撤销该条付款申请？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.cancelPayRecordData.id = id;
                        this.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/OperatePaymentAndReceiptRecord',
                                data: this.cancelPayRecordData,
                                hideLoading: true
                            })
                            .then(res => {
                                this.$util.successMsg('撤销成功');
                                this.getOrderDetails();
                                this.loading = false;
                            })
                            .catch(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请选择有效付款记录');
            }
        },
        //结算方式改变事件
        payTypeChange(event) {
            this.accountList = [];
            this.submitData.AccountName = '';
            if (event == '20') {
                this.isShowAccountZone = true;
                this.submitData.Bank = '';
                this.getAccountList(event);
            } else if (event == '25') {
                this.isShowAccountZone = true;
                this.submitData.Bank = '';
                this.getAccountList(event);
            } else if (event == '30') {
                this.isShowAccountZone = true;
                this.getAccountList(event);
            } else if (event == '35') {
                this.isShowAccountZone = true;
                this.getAccountList(event);
            } else {
                this.isShowAccountZone = false;
                this.submitData.Bank = '';
                this.submitData.AccountName = '';
                this.submitData.Account = '';
            }
        },
        getAccountList(PayType) {
            if (this.orderData.EntpCusId) {
                this.$util
                    .axiosGet({
                        url: '/api/EntpPurchaseOrder/GetEnterpriseSupplierPayAccountList',
                        data: {
                            EntpCusId: this.orderData.EntpCusId,
                            PayType: PayType
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.accountList = res.data;
                    });
            }
        },
        // 监听粘贴操作
        handlePaste(event) {
            let that = this;
            if (that.ReadOnly) {
                return;
            }
            const items = (event.clipboardData || window.clipboardData).items;
            let file = null;
            if (!items || items.length === 0) {
                this.$message.error('当前浏览器不支持本地');
                return;
            }
            // 搜索剪切板items
            for (let i = 0; i < items.length; i++) {
                if (items[i].type.indexOf('image') !== -1) {
                    file = items[i].getAsFile();
                    break;
                }
            }
            if (!file) {
                // this.$message.error("粘贴内容非图片");
                return;
            }

            if (!this.$util.uploadCheck(file)) {
                return;
            }

            let loading = this.$loading({
                lock: true,
                target: document.querySelector('#applyPayment'),
                text: '上传中',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            });
            let fd = new window.FormData();
            fd.append('file', file);
            fd.append('OrderId', that.uploadImgData.OrderId);
            fd.append('OrderType', that.uploadImgData.OrderType);
            let xhr = new XMLHttpRequest();
            xhr.open('POST', that.uploadImgUrl, true);
            xhr.setRequestHeader('access-key', that.userMsg.Token);
            xhr.setRequestHeader('reqApp', 'yqgPC');
            xhr.onload = () => {
                if (xhr.status === 200) {
                    let result = JSON.parse(xhr.responseText);
                    const reader = new FileReader();
                    reader.onload = event => {
                        that.orderImages.push({
                            Id: result.data,
                            url: event.target.result
                        });
                    };
                    reader.readAsDataURL(file);
                    loading.close();
                }
            };
            xhr.onerror = () => {
                this.$util.errorMsg('上传失败');
                loading.close();
            };
            xhr.send(fd);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`是否确定删除该流水单据？`);
        },
        onUploadRemove(file) {
            let id = file.Id;
            if (!id) {
                //刚新增的图片对象没有Id对象
                id = file.uid;
            }
            this.$util
                .axiosPost({
                    url: '/api/EntpSaleOrder/DelOrderImage?imgId=' + id
                })
                .then(res => {
                    let i = this.orderImages.findIndex(item => {
                        if (item.Id == id) {
                            return true;
                        }
                    });
                    if (i > -1) {
                        this.orderImages.splice(i, 1);
                    }
                })
                .catch(() => {
                    return false;
                });
        },
        onUploadPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogImageVisible = true;
        },
        onUploadSuccess(response, file, fileList) {
            let that = this;
            if (response.errcode == 0) {
                fileList.forEach(e => {
                    if (e.uid == file.uid) {
                        e.uid = response.data; //替换成数据库的id，为了删除功能
                        
                        that.orderImages.push({
                            Id: response.data,
                            url: e.url
                        });
                    }
                });
            } else {
                this.$util.warningMsg(response.data);
            }
        },
        accountChange(event) {
            if (event)
                this.accountList.forEach(element => {
                    if (element.Id == event) {
                        this.submitData.Bank = element.Bank;
                        this.submitData.AccountName = element.AccountName;
                        this.submitData.Account = element.Account;
                        return;
                    }
                });
        },
        addAccount() {
            this.accountDialogVisible = true;
        },
        closeAccountDialog() {
            this.accountDialogVisible = false;
            this.getAccountList(this.submitData.PayType);
        },
        getSummaries_apply(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 2) {
                    let totalAmount = 0;
                    if (data.length > 0) totalAmount = Number(data[0].SumPayable);
                    let applyTotal = data.reduce((prev, curr) => {
                        if (curr.IsCancel) return prev;
                        else return prev + Number(curr.ApplyPay);
                    }, 0);
                    sums[index] = '剩余可申请：' + (totalAmount > applyTotal ? totalAmount - applyTotal : 0).toFixed(2);
                    return;
                } else if (index === 3) {
                    let sum = data.reduce((prev, curr) => {
                        if (curr.IsCancel || !curr.IsConfirm) return prev;
                        else return prev + Number(curr.NowPay);
                    }, 0);
                    sums[index] = '已付：' + sum.toFixed(2);
                    return;
                } else {
                    sums[index] = '';
                    return;
                }
            });

            return sums;
        }
    }
};
</script>
<style lang="less" scoped>
.form-main {
    display: flex;
    > div {
        width: 33.33%;
    }
}
.btn-ctn {
    text-align: right;
}
.el-row {
    margin-bottom: 0px;
    &:last-child {
        margin-bottom: 0;
    }
}
.option-content {
    display: flex;
    line-height: 30px;
}
.addicon {
    height: 40px;
}
.account-info {
    display: flex;
    flex-direction: column;
}
.account-info span {
    margin: 5px;
}
</style>
